import { NavigateBackLink } from '@exam-management/components';
import { useParams } from '@exam-management/router';
import { PageHeader } from '@shared/components';

import { useQSetSimilarityResult } from '../../providers';

const TITLE_MAP = {
  DRAFT_TO_DRAFT: 'Check Draft Results',
  DRAFT_TO_PUBLISHED: 'Check Published Results',
  PUBLISHED_TO_PUBLISHED: 'Check Published Results',
};

export default function QSetSimilarityResultsHeader() {
  const { courseId } = useParams(`/exam-courses/:courseId/qsets/similarity-check/results`);
  const { type } = useQSetSimilarityResult();

  return (
    <PageHeader
      title={TITLE_MAP[type]}
      linkAdornment={
        <NavigateBackLink
          to={{
            pathname: '/exam-courses/:courseId/qsets',
          }}
          params={{ courseId: courseId }}
          label='Back to QSet'
          replace
        />
      }
    ></PageHeader>
  );
}
